import React, { useContext, useEffect, useState } from "react";
import * as _ from "lodash-es";
import moment from "moment-timezone";
import { Link } from "react-router-dom";
import IOrder_Item from "../../../../models/IOrder_Item";
import { NumericFormat } from "react-number-format";
import UIService from "../../../../services/UIService";
import OwTranslate from "../../../shared/OwTranslate/OwTranslate";
import { WhiteLabelLogo } from "../../../shared/WhiteLabelLogo/WhiteLabelLogo";
import OwTitle from "../../../shared/OwTitle/OwTitle";
import AddressDisplay from "../../../shared/AddressDisplay/AddressDisplay";
import OwLabel from "../../../shared/OwLabel/OwLabel";
import IOrder from "../../../../models/IOrder";
import ISupplierModel from "../../../../models/ISupplierModel";
import SupplierContext from "../../../../contexts/SupplierContext";
import IVendorModel from "../../../../models/IVendorModel";
import IAddress from "../../../../models/IAddress";
import CatalogItemService from "../../../../services/CatalogItemService";
import { DocLogo } from "../../../shared/DocLogo/DocLogo";
import { CatalogItemDescription } from "../../../shared/CatalogItemDescription/CatalogItemDescription";
import SupplierGuidEnum from "../../../../models/SupplierGuidEnum";
import "./OrderCreateSalesOrderView.scss";

type Props = {
    order: IOrder;
    showPhone: boolean;
    showEmail: boolean;
    showSku: boolean;
    showUpc: boolean;
};

export const OrderCreateSalesOrderView: React.FC<Props> = (props) => {
    const supplierModel = useContext(SupplierContext);

    const [tableClass, setTableClass] = useState<string>("");
    const [vendorModel, setVendorModel] = useState<IVendorModel>();
    const [shipTo, setShipTo] = useState<IAddress>({} as IAddress);
    const [billTo, setBillTo] = useState<IAddress>({} as IAddress);
    const [supplierShipTo, setSupplierShipTo] = useState<IAddress>({} as IAddress);

    useEffect(() => {
        let _tableClass = "table-dark";

        if (UIService.isMainViewLight()) {
            _tableClass = "";
        }

        setTableClass(_tableClass);

        setVendorModel(props.order.Vendor);

        const shipmentGroupShipTo = !_.isNil(props.order.Ship_To) ? props.order.Ship_To : props.order.Vendor?.Ship_To;
        const shipmentGroupBillTo = props.order.Vendor?.Bill_To;

        if (shipmentGroupShipTo) {
            setShipTo(shipmentGroupShipTo);
        }

        if (shipmentGroupBillTo) {
            setBillTo(shipmentGroupBillTo);
        }

        setSupplierShipTo(supplierModel.Ship_To);
    }, []);

    const OrderItemsParsed = _.map(props.order.Order_Items, (item) => {
        item.item_no = Number(item.item_no);
        return item;
    });

    const OrderItems = _.sortBy(OrderItemsParsed, ["item_no", "asc"]);

    const orderDate = moment(props.order.confirmed_date || props.order.submit_date || props.order.created_at).format("MM/DD/YYYY");

    const orderNumsArr: string[] = [];
    const poNumsArr: string[] = [];
    const notes = props.order.note || "";

    orderNumsArr.push(props.order.name || "");

    if (props.order.po_no) {
        poNumsArr.push(props.order.po_no);
    }

    const orderNums = (
        <Link className={"no-text-style"} to={`/orders/${props.order.guid}/entry`}>
            {props.order.name}
        </Link>
    );
    const poNums = poNumsArr.join(",");

    const orderItemRows = _.map(OrderItems, (orderItem: IOrder_Item, index: number) => {
        const rowTotal = orderItem.total || Number(orderItem.cost_price_frozen) * Number(orderItem.qty);

        const pricePerUnit = orderItem.net_price || Number(orderItem.cost_price_frozen);

        return (
            <tr>
                <td>{orderItem.item_no}</td>
                <td>{orderItem.Catalog_Item?.name}</td>
                <td>{orderItem.Catalog_Item?.sku}</td>
                <td>
                    {orderItem.description ||
                        (orderItem.Catalog_Item ? (
                            <CatalogItemDescription catalogItem={orderItem.Catalog_Item!} priceGroup={props.order?.Price_Group} />
                        ) : (
                            ""
                        ))}
                </td>
                <td>{orderItem.Selected_Unit?.unit_abbr || orderItem.Catalog_Item?.Unit_Of_Measurement?.abbreviation || ""}</td>
                <td className={"text-end"}>
                    <NumericFormat
                        value={orderItem.qty}
                        displayType={"text"}
                        thousandSeparator={true}
                        decimalScale={supplierModel.qty_precision || 0}
                        fixedDecimalScale={true}
                    />
                </td>
                <td className={"text-end"}>
                    <NumericFormat
                        value={pricePerUnit}
                        displayType={"text"}
                        thousandSeparator={true}
                        decimalScale={supplierModel.pricing_precision || 2}
                        fixedDecimalScale={true}
                        prefix={"$"}
                    />
                </td>
                <td className={"text-end"}>
                    <NumericFormat
                        value={rowTotal}
                        displayType={"text"}
                        thousandSeparator={true}
                        decimalScale={supplierModel.pricing_precision || 2}
                        fixedDecimalScale={true}
                        prefix={"$"}
                    />
                </td>
            </tr>
        );
    });

    const hasBillToName = true;
    const hasShipToName = true;

    // if (!shipmentGroupBillTo?.name?.length || !shipmentGroupBillTo?.company_name?.length) {
    //     let billToNameSame = false;
    //     let billToCompanyNameSame = false;
    //
    //     if (shipmentGroupBillTo?.name === vendorModel?.name) {
    //         billToNameSame = true;
    //     }
    //
    //     if (shipmentGroupBillTo?.company_name === vendorModel?.name) {
    //         billToCompanyNameSame = true;
    //     }
    //
    //     if (!billToNameSame && !billToCompanyNameSame) {
    //         hasBillToName = false;
    //     }
    // }
    //
    // if (!shipmentGroupShipTo?.name?.length || !shipmentGroupShipTo?.company_name?.length) {
    //     let shipToNameSame = false;
    //     let shipToCompanyNameSame = false;
    //
    //     if (shipmentGroupShipTo?.name === vendorModel?.name) {
    //         shipToNameSame = true;
    //     }
    //
    //     if (shipmentGroupShipTo?.company_name === vendorModel?.name) {
    //         shipToCompanyNameSame = true;
    //     }
    //
    //     if (!shipToNameSame && !shipToCompanyNameSame) {
    //         hasShipToName = false;
    //     }
    //
    //     if (props.order.client_id) {
    //         hasShipToName = true;
    //     }
    // }

    return (
        <div className="OrderCreateSalesOrderView">
            <div className={"top-row"}>
                <div className={"d-flex justify-content-between"}>
                    <div className={"p-1 black-box"}>
                        {supplierModel.Doc_Logo ? (
                            <DocLogo maxWidth={"20rem"} height={"auto"} />
                        ) : (
                            <WhiteLabelLogo height={"auto"} maxWidth={"20rem"} maxHeight={"15rem"} />
                        )}
                        <OwTitle disableTranslation={true} title={supplierModel.name} tag={"h5"} className={"mb-0"} />
                        <div>{supplierShipTo.address_line_one}</div>
                        <div>{supplierShipTo.address_line_two}</div>
                        <div>
                            {supplierShipTo.city}, {supplierShipTo.state} {supplierShipTo.postal_code}
                        </div>
                        <div className={"mt-2"}>
                            <div className={props.showPhone && supplierModel.phone ? "" : "d-none"}>
                                <b>
                                    <OwTranslate defaultMessage={"phone"} id={"phone"} />:
                                </b>{" "}
                                {supplierModel.phone}
                            </div>
                            <div className={props.showEmail && supplierModel.email ? "" : "d-none"}>
                                <b>
                                    <OwTranslate defaultMessage={"email"} id={"email"} />:
                                </b>{" "}
                                {supplierModel.email}
                            </div>
                        </div>
                    </div>
                    <div className={"text-end d-md-flex flex-column align-items-end"}>
                        <h3>
                            <OwTranslate defaultMessage={"Sales Order"} id={"sales_order"} />
                        </h3>
                        <p>Date: {moment().format("MM/DD/YYYY")}</p>
                    </div>
                </div>
            </div>

            <div className={"row bill-to-ship-to-row mt-5"}>
                <div className={"col-4 black-box " + (supplierModel.guid === SupplierGuidEnum.VERMONT ? "d-none" : "")}>
                    <OwTitle leftIconName={"fal fa-building"} className={"underline"} title={"bill_to"} tag={"h5"} />
                    {!hasBillToName ? <OwTitle title={props.order.Vendor?.name || ""} tag={"h5"} disableTranslation={true} /> : null}
                    <AddressDisplay
                        address={billTo}
                        showCompanyName={true}
                        showName={true}
                        // showPhone={props.showBillToPhone}
                        hideMobile={true}
                        hideFax={true}
                        hideEmail={true}
                        nameTag={"h5"}
                    />
                </div>

                <div className={"col-4 black-box " + (supplierModel.guid === SupplierGuidEnum.VERMONT ? "" : "border-left-0")}>
                    {props.order.is_local_pickup ? (
                        <OwTitle leftIconName={"fal fa-hand-holding-box"} title={"local_pickup"} tag={"h5"} className={"underline"} />
                    ) : (
                        <OwTitle
                            leftIconName={"fal fa-truck"}
                            title={props.order.is_local_delivery ? "deliver_to" : "ship_to"}
                            tag={"h5"}
                            className={"underline"}
                        />
                    )}
                    {!hasShipToName ? <OwTitle title={props.order.Vendor?.name || ""} tag={"h5"} disableTranslation={true} /> : null}
                    <AddressDisplay
                        address={shipTo}
                        showCompanyName={!props.order.client_id}
                        showName={true}
                        // showPhone={props.showShipToPhone}
                        hideEmail={true}
                        hideFax={true}
                        hideMobile={true}
                        nameTag={"h5"}
                    />
                </div>
            </div>

            <div className={"table-responsive mt-2"}>
                <div className={""}>
                    <table className={"table table-bordered " + tableClass}>
                        <tbody>
                            <tr>
                                <th>
                                    <OwLabel title={"order_date"} className={"mb-0"} />
                                </th>
                                <th>
                                    <OwLabel title={"order_no"} className={"mb-0"} />
                                </th>
                                <th>
                                    <OwLabel title={"po_no"} className={"mb-0"} />
                                </th>
                                <th>
                                    <OwLabel title={"notes"} className={"mb-0"} />
                                </th>
                            </tr>
                            <tr>
                                <td>{orderDate}</td>
                                <td>{orderNums}</td>
                                <td>{poNums}</td>
                                <td>{notes}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div className={"table-responsive"}>
                <table className={"table table-bordered " + tableClass}>
                    <tbody>
                        <tr>
                            <th>
                                <OwLabel title={"no"} className={"mb-0"} />
                            </th>
                            <th>
                                <OwLabel title={"item"} className={"mb-0"} />
                            </th>
                            <th>
                                <OwLabel title={"sku"} className={"mb-0"} />
                            </th>
                            <th>
                                <OwLabel title={"description"} className={"mb-0"} />
                            </th>
                            <th>
                                <OwLabel title={"uom"} className={"mb-0"} />
                            </th>
                            <th className={"text-end"}>
                                <OwLabel title={"order_qty"} className={"mb-0"} />
                            </th>
                            <th className={"text-end"}>
                                <OwLabel title={"unit_price"} className={"mb-0"} />
                            </th>
                            <th className={"text-end"}>
                                <OwLabel title={"total"} className={"mb-0"} />
                            </th>
                        </tr>
                        {orderItemRows}
                    </tbody>
                </table>
            </div>
        </div>
    );
};
